// import { Table, Space } from 'antd';
// import React from 'react';
import Main from "../components/layout/Main";
import Header from "../components/layout/Header";
// import { useHistory } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import {
  ArrowLeftOutlined,
  BarChartOutlined,
  DashboardTwoTone,
  BranchesOutlined,
  DashboardOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import { useEffect } from "react";
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Input,
  Space,
  Table,
  Badge,
  Spin,
  Tooltip,
  DatePicker,
} from "antd";
import React, { useRef, useState } from "react";
import Highlighter from "react-highlight-words";
import { get } from "../Libraries/Ajax/HttpService";
import back from "../assets/images/back.svg";
import { useDistrict } from "../utils/DistrictContext";
import { Skeleton } from "antd";
import dayjs from "dayjs";
const Devices = () => {
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [loading, setloading] = useState(true);
  const [data, setdata] = useState([]);
  const { selectedDistrict } = useDistrict();
  const [page, setPage] = useState(1);
  const [pageLimit] = useState(20);
  const [totalPages, setTotalPages] = useState(1000);
  const [totalRecords, setTotalRecords] = useState(0);
  const [isStreaming, setIsStreaming] = useState(false);
  // let history = useHistory();
  const navigate = useNavigate();

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const onRedirection = (event) => {
    // history.push('/dashboard');
    // window.history.back();
    navigate(-1);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  const getColumnSearchProps = (dataIndex, customName) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          // placeholder={`Search ${dataIndex}`}
          placeholder={`Search for ${customName || dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Back
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columns = [
    {
      title: (
        <div className="d-flex align-items-center justify-content-center w-100">
          Active
          <Tooltip
            color="white"
            styles={{ body: { color: "black" } }}
            title={
              <div>
                <div
                  className="fw-bold mb-2 text-black"
                  style={{ fontSize: "13px" }}
                >
                  Depends on the Endpoint Status
                </div>

                <div className="text-black">
                  <Badge color="green" /> <span>Active</span>
                </div>
                <div className="text-black">
                  <Badge color="#8b0000" /> <span>Inactive</span>
                </div>
              </div>
            }
          >
            <span
              className="ms-2 d-inline-flex"
              style={{ transform: "translateY(2px)", cursor: "help" }}
            >
              <InfoCircleOutlined
                className="text-blue"
                style={{ fontSize: "12px" }}
              />
            </span>
          </Tooltip>
        </div>
      ),

      dataIndex: "endpoint_status",
      key: "endpoint_status",
      width: "7%",
      align: "center",
      filters: [
        { text: "Active", value: "Active" },
        { text: "Inactive", value: "Inactive" },
      ],
      onFilter: (value, record) => record.endpoint_status === value,
      render: (endpoint_status) =>
        endpoint_status === "Active" ? (
          <div className="circle"></div>
        ) : (
          <div className="circlered"></div>
        ),
    },

    {
      title: "Operational", // Your existing Tooltip title logic here
      dataIndex: "operational",
      key: "operational",
      align: "center",
      width: "10%",
      filters: [
        { text: "Green (Healthy)", value: "green" },
        { text: "Orange (Delayed)", value: "orange" },
        { text: "Red (Offline)", value: "red" },
      ],
      onFilter: (value, record) => record.operational === value,

      // ADD THIS SORTER LOGIC:
      sorter: (a, b) => {
        const priority = { orange: 1, red: 2, green: 3 };
        return priority[a.operational] - priority[b.operational];
      },
      // Ensure it sorts automatically or stays sorted
      defaultSortOrder: "ascend",

      render: (status) =>
        status === "green" ? (
          <div className="circle"></div>
        ) : status === "red" ? (
          <div className="circlered"></div>
        ) : (
          <div className="circleorange"></div>
        ),
    },

    {
      title: "Account",
      dataIndex: "overided_name",
      key: "overided_name",
      // ...getColumnSearchProps("overided_name"),
      ...getColumnSearchProps("overided_name", "Account Name"),
      sorter: (a, b) => a.overided_name.localeCompare(b.overided_name),
      sortDirections: ["descend", "ascend"],
      width: "15%",
    },
    {
      title: "Meter ID",
      dataIndex: "meter_id",
      key: "meter_id",
      // ...getColumnSearchProps("meter_id"),
      ...getColumnSearchProps("meter_id", "Meter ID"),
      // sorter: (a, b) => a.meter_id - b.meter_id,
      // sortDirections: ['descend','ascend'],
      width: "7%",
    },
    {
      title: "Register",
      dataIndex: "register_number",
      key: "register_number",
      ...getColumnSearchProps("register_number", "Register Number"),
      // sorter: (a, b) => a.register_number.length - b.register_number.length,
      // sortDirections: ['descend', 'ascend'],
      width: "7%",
    },

    {
      title: "Date Range",
      dataIndex: "date_range",
      key: "date_range",
      width: "12%",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
          <DatePicker
            picker="month" // This restricts the calendar to Month and Year selection
            style={{ marginBottom: 8, display: "block" }}
            value={selectedKeys[0] ? dayjs(selectedKeys[0]) : null}
            onChange={(date) => {
              // Store the date as a string (e.g., "2026-02")
              setSelectedKeys(date ? [date.format("MMM YYYY")] : []);
            }}
          />
          <Space>
            <Button
              type="primary"
              onClick={() => confirm()}
              icon={<SearchOutlined />}
              size="small"
              style={{ width: 90 }}
            >
              Search
            </Button>
            <Button
              onClick={() => {
                clearFilters && handleReset(clearFilters);
                confirm();
              }}
              size="small"
              style={{ width: 90 }}
            >
              Reset
            </Button>
          </Space>
        </div>
      ),
      filterIcon: (filtered) => (
        <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
      ),
      onFilter: (value, record) => {
        const range = record.date_range;
        if (!range) return false;

        // Normalize both to compare (e.g., "jan 2026")
        const normalizedData = range.toLowerCase();
        const normalizedSearch = value.toLowerCase();

        return normalizedData.includes(normalizedSearch);
      },
    },
    {
      title: "Meter Type",
      dataIndex: "meter_type",
      key: "meter_type",
      //  ...getColumnSearchProps('meter_type'),
      ...getColumnSearchProps("meter_type", "Meter Type"),
      sorter: (a, b) => a.meter_type.localeCompare(b.meter_type),
      sortDirections: ["descend", "ascend"],
      width: "10%",
    },
    {
      title: "Model",
      dataIndex: "meter_model",
      key: "meter_model",
      ...getColumnSearchProps("meter_model", "Meter Model"),
      // sorter: (a, b) => a.meter_model.length - b.meter_model.length,
      // sortDirections: ['descend', 'ascend'],
      width: "10%",
    },
    {
      title: "Size",
      dataIndex: "meter_size",
      key: "meter_size",
      // ...getColumnSearchProps('meter_size'),
      sorter: (a, b) => a.meter_size - b.meter_size,
      sortDirections: ["descend", "ascend"],
      width: "10%",
    },
    {
      title: "Dials",
      dataIndex: "dials",
      key: "dials",
      // ...getColumnSearchProps('dials'),
      sorter: (a, b) => a.dials - b.dials,
      sortDirections: ["descend", "ascend"],
      width: "10%",
    },
    {
      title: "Resolution",
      dataIndex: "register_resolution",
      key: "register_resolution",
      // ...getColumnSearchProps('register_resolution'),
      sorter: (a, b) => a.register_resolution - b.register_resolution,
      sortDirections: ["descend", "ascend"],
      width: "10%",
    },
    {
      title: "Continuous Flow",
      dataIndex: "meter_continuous_flow",
      key: "meter_continuous_flow",
      width: "12%",
    },
  ];
  const onselectClickss = () => {
    navigate("/schematics");
  };
  const onselectClick = () => {
    navigate("/stats");
  };
  const onselectClicks = () => {
    navigate("/devices");
  };

  const fetchMeters = async () => {
    setloading(true);
    try {
      // 1. INITIAL FETCH: Get first 50 for instant UI feedback
      const initialRes = await get(`apis/meter_list?page=1&page_limit=50`);
      const initialData = initialRes.data?.data || {};
      const firstBatch = initialData.meters || [];

      setdata(firstBatch);
      setTotalRecords(initialData.total_records || 0);
      setloading(false); // UI is now interactive

      // 2. BACKGROUND FETCH: Get everything else if there are more records
      if (initialData.total_records > 50) {
        setIsStreaming(true);
        // Fetch a large limit (adjust based on your API's max allowed limit)
        const secondaryRes = await get(
          `apis/meter_list?page=1&page_limit=5000`,
        );
        const fullData = secondaryRes.data?.data?.meters || [];

        // Update data with the full set
        setdata(fullData);
        setIsStreaming(false);
      }
    } catch (err) {
      console.error("Error fetching data:", err);
      setloading(false);
      setIsStreaming(false);
    }
  };

  useEffect(() => {
    fetchMeters();
  }, [selectedDistrict]);
  useEffect(() => {
    getData(page);
  }, [selectedDistrict, page]);
  const getData = async (currentPage) => {
    setloading(true);
    try {
      const res = await get(
        `apis/meter_list?page=${currentPage}&page_limit=${pageLimit}`,
      );
      const result = res.data?.data || {};
      setdata(result.meters || []);
      setTotalRecords(result.total_records || 0);
      setTotalPages(result.total_pages || 1);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      setloading(false);
    }
  };
  const handleNext = () => {
    if (page < totalPages) setPage((prev) => prev + 1);
  };
  const handlePrev = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };
  return (
    <>
      {/* <head>
        <title> {window.location.href.indexOf("mizuwatch.com") > -1?"MizuWatch":"MizuSmart"}  </title></head> */}
      <Header />
      <Main>
        <div>
          <div className="d-flex align-items-center justify-content-between mb-4">
            {/* <div className="d-flex fs-30 gap-3">
                            <ArrowLeftOutlined onClick={onRedirection} />
                            <h3 className="my-4">Devices</h3>
                        </div> */}
            <div className="d-flex align-items-center">
              {/* <ArrowLeftOutlined onClick={onRedirection} /> */}
              <img
                src={back}
                alt=""
                style={{ width: "10px", cursor: "pointer" }}
                onClick={onRedirection}
              />
              {/* <h3 className="mb-0 ms-3">Devices</h3> */}
              <div className="d-flex align-items-center">
                <div
                  className="new-box-padding   align-self-center c-pointer"
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                  onClick={onselectClickss}
                >
                  {/* <BranchesOutlined className="me-1" /> */}
                  Digital Twin{" "}
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding   align-self-center c-pointer "
                  style={{
                    borderBottom: "2px solid #ccc",
                  }}
                  onClick={onselectClick}
                >
                  {/* <BarChartOutlined className="me-1" /> */}
                  Stats{" "}
                </div>
                <div
                  className=""
                  style={{ width: "2px", height: "25px", background: "#ccc" }}
                ></div>
                <div
                  className="new-box-padding  text-blue  align-self-center c-pointer  "
                  style={{
                    borderBottom: "2px solid #1998f0",
                    borderRadius: "0",
                  }}
                  onClick={onselectClicks}
                >
                  {/* <DashboardOutlined title="Meter" className="me-1" /> */}
                  Meters
                </div>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="example">
              <Spin />
            </div>
          ) : (
            <>
              {/* Background Loading Indicator (Subtle) */}
              {isStreaming && (
                <div
                  style={{
                    textAlign: "right",
                    marginBottom: "5px",
                    color: "#1890ff",
                    fontSize: "12px",
                  }}
                >
                  <Spin size="small" className="me-2" />
                  Syncing all records for search...
                </div>
              )}

              <Table
                columns={columns}
                dataSource={data}
                className="styleRemove devices-table outliers-sty"
                loading={false}
                rowKey={(record) => record.meter_id + record.register_number}
                pagination={{
                  defaultPageSize: 20, // Set the initial size
                  showSizeChanger: true,
                  pageSizeOptions: ["20", "50", "100", "500"], // Added 500 for large datasets
                  showTotal: (total) => `Total ${total} items`,
                  position: ["bottomRight"],
                  // Ant Design handles the state internally, but you can add this
                  // to ensure the UI refreshes correctly if you have specific logic
                  onChange: (page, pageSize) => {
                    console.log(`Page: ${page}, PageSize: ${pageSize}`);
                  },
                }}
                scroll={{
                  x: 800,
                  y: 580,
                }}
              />
            </>
          )}
        </div>
      </Main>
    </>
  );
};
export default Devices;
